import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams, withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';

import UserPage from './UserPage';
import PhoneAuthModal from '../../../../components/auth/PhoneAuthModal';
import { trackAuthEvent } from '../../utilities/analytics';
import { MeQuery } from '../../../../graphql/queries/account';
import { isShutterbug } from '../../../../util/account';
import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import AppDownloadQRUpsell from '../../../../components/global/AppDownloadQRUpsell';
import withGoogleRecaptchaProvider from '../../../../components/auth/hocs/withGoogleRecaptchaProvider';

const propTypes = {
  loading: PropTypes.bool,
  authenticated: PropTypes.bool,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const UserPageWrapper = ({ loading, authenticated, user }) => {
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    if (authenticated && user && isShutterbug(user)) {
      history.replace(`/app/shutterbug/profile/@${params.username}`);
    }
  }, [user, authenticated]);

  if (loading || (authenticated && isShutterbug(user))) {
    return <FullScreenLoader />;
  }

  return (
    <Fragment>
      <AppDownloadQRUpsell />

      <UserPage />

      <PhoneAuthModal onLogin={trackAuthEvent} />
    </Fragment>
  );
};

UserPageWrapper.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const withUserData = graphql(MeQuery, {
  props: ({ data: { me, loading } = {} }) => ({
    user: me,
    loading,
  }),
  skip: ({ authenticated }) => !authenticated,
});

export default compose(
  withRouter,
  withGoogleRecaptchaProvider,
  connect(mapStateToProps),
  withUserData,
)(UserPageWrapper);
